import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.96967 12.9697C4.67678 13.2626 4.67678 13.7374 4.96967 14.0303C5.26256 14.3232 5.73744 14.3232 6.03033 14.0303L11 9.06066V21.25C11 21.6642 11.3358 22 11.75 22C12.1642 22 12.5 21.6642 12.5 21.25V9.06066L17.4697 14.0303C17.7626 14.3232 18.2374 14.3232 18.5303 14.0303C18.8232 13.7374 18.8232 13.2626 18.5303 12.9697L12.2803 6.71967C11.9874 6.42678 11.5126 6.42678 11.2197 6.71967L4.96967 12.9697Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.75 3.5C4.33579 3.5 4 3.16421 4 2.75C4 2.33579 4.33579 2 4.75 2H19.25C19.6642 2 20 2.33579 20 2.75C20 3.16421 19.6642 3.5 19.25 3.5H4.75Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgUpload;
